import { AdminCard, AdminHeader, Field } from "./AdminShell";

const samples = [
  "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=900&q=80"
];

export default function MediaLibrary() {
  return (
    <div>
      <AdminHeader title="Media" description="Free deployment mode stores media as image URLs. Upload controls stay hidden until R2 is configured later." />
      <div className="grid gap-6 lg:grid-cols-[380px_1fr]">
        <AdminCard title="Add Image URL">
          <div className="space-y-4">
            <Field label="Image Name"><input className="input" placeholder="Hero lifestyle image" /></Field>
            <Field label="Image URL"><input className="input" placeholder="https://..." /></Field>
            <Field label="Alt Text"><input className="input" placeholder="Product on a clean desk" /></Field>
            <button className="btn-primary w-full">Save Media URL</button>
          </div>
        </AdminCard>
        <AdminCard title="Saved Images">
          <div className="grid gap-4 md:grid-cols-3">
            {samples.map((url) => <div key={url} className="rounded-[22px] bg-[#FDF9F1] p-3"><img src={url} className="aspect-[4/3] w-full rounded-[18px] object-cover" /><p className="mt-3 truncate text-xs text-slate-500">{url}</p></div>)}
          </div>
        </AdminCard>
      </div>
    </div>
  );
}
